<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-12 col-lg-9 mx-auto">
        <p>
          Serviço de integração via API para o controle e gestão da carteira do corretor, através desse serviço a corretora terá acesso as emissões, apólices, endossos, comissões, boletos e todo o histórico dos negócios fechados na Tokio Marine.
        </p>
      </div>
    </div>
    <!-- passo 1 -->
    <div class="row passos mt-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>1° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Acesse o Portal Parceiros e clique no menu "Eu Corretor"!
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-vendas-1.png" alt="">
      </div>
    </div>
    <!-- passo 2 -->
    <div class="row passos mt-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>2° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Na sessão de "Integrações e Serviços" clique em "Adesão Gestão de Carteira".
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-gestao-1.png" alt="">
      </div>
    </div>
    <!-- passo 3 -->
    <div class="row passos mt-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>3° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Clique em "Iniciar Assinatura".
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-gestao-2.png" alt="">
      </div>
    </div>
    <!-- passo 4 -->
    <div class="row passos mt-5 mb-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>4° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          O corretor deverá informar um e-mail válido da corretora para iniciar a assinatura e clicar em "próximo".
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-gestao-3.png" alt="">
      </div>
    </div>
    <!-- passo 5 -->
    <div class="row passos mt-5 mb-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>5° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          É possível integrar todos os códigos de corretores com o mesmo CNPJ, selecione os códigos desejados e clique em "próximo
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-gestao-4.png" alt="">
      </div>
    </div>
    <!-- passo 6 -->
    <div class="row passos mt-5 mb-5">
      <div class="col-12 col-md-12 col-lg-10 mx-auto">
        <h1>6° PASSO</h1>
        <hr class="divider">
        <p class="mb-3">
          Selecione a opção “Web Service” e clique em "assinar".
        </p>
        <img src="/massificados/corporativo/gerenciador-parceiros-ui/fluxo/img/fluxo-gestao-5.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {

    };
  },
  mounted() {

  },
  computed: {

  },
  methods: {

  }
};
</script>
